type props = {
  href?: string;
  className?: string;
  onClick?: (argument: any) => void;
  children?: React.ReactNode;
  target?: string;
  rawHtml?: string;
};

export const PEILinkExternal = ({
  href = '',
  className = '',
  children,
  onClick,
  target = '_blank',
  rawHtml = '',
}: props) => {
  if (rawHtml) {
    return (
      <a
        href={href}
        className={className}
        target={target}
        onClick={onClick}
        dangerouslySetInnerHTML={{ __html: rawHtml }}
      >
        {children}
      </a>
    );
  }

  return (
    <a href={href} className={className} target={target} onClick={onClick}>
      {children}
    </a>
  );
};
